export default __webpack_public_path__ + "static/SectionTwo_01_03@2x-c6292294fe135c14f5254495bf4c2a33.png";